import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=4f6062b1&scoped=true&"
import script from "./msg.vue?vue&type=script&lang=js&"
export * from "./msg.vue?vue&type=script&lang=js&"
import style0 from "./msg.vue?vue&type=style&index=0&id=4f6062b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6062b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6062b1')) {
      api.createRecord('4f6062b1', component.options)
    } else {
      api.reload('4f6062b1', component.options)
    }
    module.hot.accept("./msg.vue?vue&type=template&id=4f6062b1&scoped=true&", function () {
      api.rerender('4f6062b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pub/components/sys/msg.vue"
export default component.exports